import { takeLatest, call, put } from 'redux-saga/effects';
import { TAction } from 'shared/types';
import {
  getWebhooks,
  deleteWebhook,
  removeWebhook,
  setWebhooks,
  getWebhooksEventTypes,
  getDictionaryWebhooksEventTypes,
  createNewWebhook,
  createWebhookData,
  updateWebhookSuccess,
  updateWebhookData
} from './webhooks.redux';
import { openNotificationMessage } from 'shared/utils/NotificationMessages';
import { NotificationMessages } from 'shared/enums';
import { AxiosResponse } from 'axios';
import {
  IWebhook,
  IWebhookDictionary
} from 'shared/interfaces/webhook.interface';
import WebhooksService from 'shared/services/WebhooksService';

function* getAllWebkooks({ payload }: TAction<IWebhook[]>) {
  try {
    const result: AxiosResponse<IWebhook[]> = yield call(
      WebhooksService.getAllWebhooks,
      payload
    );
    yield put(setWebhooks(result));
  } catch (error) {
    console.log('error', error);
  }
}

function* handleDeleteWebhook({ payload }: TAction<string>) {
  try {
    yield call(WebhooksService.deleteWebhook, payload);
    yield put(removeWebhook(payload));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Webhook was successfully deleted.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message: error?.response?.data?.message || 'Unable to delete webhook.'
    });
  }
}

function* getAllWebhooksEvents({ payload }: TAction<IWebhookDictionary[]>) {
  try {
    const result: AxiosResponse<IWebhookDictionary[]> = yield call(
      WebhooksService.getWebhooksDictionary,
      payload
    );
    yield put(getWebhooksEventTypes(result));
  } catch (error) {
    console.log('error', error);
  }
}
function* createWebhook({ payload }: TAction<IWebhook>) {
  try {
    const result: AxiosResponse<IWebhook> = yield call(
      WebhooksService.createWebhook,
      payload
    );
    yield put(createNewWebhook(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Webhook was successfully created.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.error['code'] === 11000
          ? 'Webhook creation was unsuccessful. The URL must be unique.'
          : error?.response?.data?.message ||
            'Webhook creation was unsuccessful.'
    });
  }
}

function* handleUpdateWebhook({
  payload
}: TAction<{
  data: IWebhook;
  id: string;
}>) {
  try {
    const result: AxiosResponse<IWebhook> = yield call(
      WebhooksService.updateWebhook,
      payload
    );
    yield put(updateWebhookSuccess(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Webhook was successfully updated.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message || 'Webhook updating was unsuccesful.'
    });
  }
}

function* Webhooks() {
  yield takeLatest(getWebhooks.type, getAllWebkooks);
  yield takeLatest(deleteWebhook.type, handleDeleteWebhook);
  yield takeLatest(getDictionaryWebhooksEventTypes.type, getAllWebhooksEvents);
  yield takeLatest(createWebhookData.type, createWebhook);
  yield takeLatest(updateWebhookData.type, handleUpdateWebhook);
}

export default Webhooks;
